import HttpService from './HttpService';

const UserApi = HttpService('/api/accountjwt/');

export default {
  login(username, password) {
    const data = { username, password };
    const apiAction = 'Login';
    return UserApi.post(`${apiAction}`, data);
  },
  loginWithAadCookie() {
    const data = {};
    const apiAction = 'LoginWithAadCookie';
    return UserApi.post(`${apiAction}`, data);
  },
  logout() {
    const apiAction = 'Logout';
    return UserApi.post(`${apiAction}`);
  },
  reloadUserData(username, activeSiteId) {
    const data = { username, currentActiveSiteId: activeSiteId };
    const apiAction = 'ReloadUserData';
    return UserApi.post(`${apiAction}`, data);
  },
  changePassword(currentPassword, newPassword, newPasswordConfirmed) {
    const apiAction = 'ChangePassword';
    return UserApi.post(apiAction, { currentPassword, newPassword, newPasswordConfirmed });
  },
  getUserDetailsFromToken() {
    const queryString = null;
    const apiAction = 'GetUserDetailsFromToken';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return UserApi.get(fullUrl);
  },
  getUISettings() {
    const queryString = null;
    const apiAction = 'GetUiSettings';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return UserApi.get(fullUrl);
  },
  checkUserTokenIsValid() {
    const apiAction = 'CheckUserTokenIsValid';
    return UserApi.get(apiAction);
  },
};
